import React, { Component } from 'react'
import { SizeMe } from 'react-sizeme'
const PictureContainer = (props) => {
    const inputFile = React.useRef(null)
    const [file, setFile] = React.useState(null)
    const [dimensions, setDimensions] = React.useState(null)

    const onButtonClick = () => {
        inputFile.current.click()
    }

    const onChangeFile = (event) => {
        event.stopPropagation()
        event.preventDefault()
        var file = event.target.files[0]
        let reader = new FileReader()
        reader.addEventListener(
            'load',
            function () {
                let uri = reader.result
                props.handleFile(uri)
            },
            false
        )
        if (file.type.includes('image')) {
            reader.readAsDataURL(file)
        } else {
            alert('File is not an image')
        }

        // setFile(file);
    }

    let onDrop =
        props.onDrop ||
        function (e) {
            return null
        }

    return (
        <>
            {/* <SizeMe
    monitorHeight={true}>{
      ({ size }) => {
        return ( */}
            <div onClick={onButtonClick} style={props.style || { flex: 1 }} onDrop={onDrop}>
                <img
                    style={{ height: '100%', width: '100%', objectFit: 'contain' }}
                    src={props.src || 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='}
                />
            </div>
            {/* </SizeMe> */}
            <input
                type="file"
                id="file"
                ref={inputFile}
                style={{ display: 'none' }}
                onChange={onChangeFile}
            />
        </>
    )
}

export default PictureContainer
